export default __webpack_public_path__ + "68f2d98cced36548b72ca533054e24ba.jpg";